import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { BUSINESS } from "@/config/businessConfig";
import { SERVICES } from "@/data/services";

export const Footer = () => (
  <footer className="relative bg-[var(--char)] border-t border-[var(--line)] overflow-hidden" data-testid="site-footer">
    <div className="hazard h-2 w-full" />
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 pt-20 pb-10">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <Logo testId="footer-logo" />
          <p className="mt-5 text-zinc-400 max-w-sm leading-relaxed">
            Assembly and installation for homes and businesses in Woodstock, Ingersoll and across Oxford County, Ontario.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-5">Services</p>
          <ul className="space-y-2.5">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.id}><Link to={`/services#${s.id}`} className="text-zinc-300 hover:text-[var(--orange)] transition-colors">{s.title}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow mb-5">Company</p>
          <ul className="space-y-2.5">
            {[["/about", "About"], ["/services", "All Services"], ["/contact", "Request a Quote"]].map(([to, l]) => (
              <li key={to}><Link to={to} className="text-zinc-300 hover:text-[var(--orange)] transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-5">Contact</p>
          <ul className="space-y-3 text-zinc-300">
            <li><a href={BUSINESS.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white"><Phone className="w-4 h-4 text-[var(--orange)]" />{BUSINESS.phoneDisplay}</a></li>
            <li><a href={BUSINESS.emailHref} data-testid="footer-email" className="flex items-center gap-3 hover:text-white break-all"><Mail className="w-4 h-4 text-[var(--orange)] shrink-0" />{BUSINESS.email}</a></li>
            <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[var(--orange)]" />{BUSINESS.baseCity}</li>
          </ul>
        </div>
      </div>
      <p className="font-display font-black uppercase text-[18vw] lg:text-[13rem] leading-[0.8] tracking-tight text-outline mt-16 select-none" aria-hidden="true">
        AssemblePro
      </p>
      <div className="mt-8 pt-6 border-t border-[var(--line)] flex flex-col sm:flex-row justify-between gap-3 text-sm text-zinc-400">
        <p>© {new Date().getFullYear()} {BUSINESS.name}. Serving Woodstock, Ingersoll & Oxford County, ON.</p>
        <Link to="/admin" className="hover:text-zinc-200" data-testid="footer-admin-link">Owner login</Link>
      </div>
    </div>
  </footer>
);
